/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Hidden, View } from '@az/starc-ui'
import { FC, PropsWithChildren, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useLocation } from 'react-router-dom'
import { ErrorPage } from './ErrorPage'
import { NavigationBackButton } from './NavigationBackButton'
import { SidebarNavigation } from './SidebarNavigation'
import { Header } from '../Header/Header'

interface Props extends PropsWithChildren {
  hideNavigation?: boolean
}

export const Layout: FC<Props> = ({ hideNavigation, children }) => {
  const [error, setError] = useState(false)

  const viewHeight = '100vh'
  const headerHeight = '50px'
  const padding = 2
  const location = useLocation()
  const inDashboard = location.pathname == '/'

  const sideBarWidth = inDashboard && !error ? '200px' : '0px'
  const backButtonHeight = !inDashboard ? '50px' : '0px'

  return (
    <View
      height={viewHeight}
      direction="column"
      attributes={{
        style: {
          overflowY: 'scroll',
          overflowX: 'hidden',
        },
      }}
    >
      <Header height={headerHeight} disabled={error} />
      <View direction="row" padding={[padding, 0]}>
        <Hidden hide={hideNavigation || !inDashboard || error}>
          <View
            width={sideBarWidth}
            attributes={{
              style: {
                paddingLeft: `var(--st-unit-${padding})`,
              },
            }}
          >
            <SidebarNavigation />
          </View>
        </Hidden>
        <View width={`calc(100% - ${sideBarWidth})`}>
          <Hidden hide={inDashboard || error}>
            <View height={backButtonHeight} padding={padding}>
              <NavigationBackButton />
            </View>
          </Hidden>
          <View height={`calc(100% - ${backButtonHeight})`} padding={padding}>
            <ErrorBoundary
              resetKeys={[error]}
              onReset={() => setError(false)}
              FallbackComponent={({ error, resetErrorBoundary }) => {
                setError(true)
                return <ErrorPage error={error} reset={resetErrorBoundary} />
              }}
            >
              {children}
            </ErrorBoundary>
          </View>
        </View>
      </View>
    </View>
  )
}
